export default __webpack_public_path__ + "static/media/open-book.7378ee7a.svg";